import { make } from 'vuex-pathify';
import { CompanyService } from '@/services/companies';
import { errorCatch } from '../utils';
import { Company } from '@/models/company';

const companyService = new CompanyService();

export const state = {
  loading: false,
  companies: [],
  companyInstance: {},
  lastRemovedCompany: {},
  lastEditedCompany: {},
  error: {}
};

export const mutations = {
  REMOVE_COMPANY(state: any, payload: any) {
    const index = state.companies.indexOf(payload);
    state.companies.splice(index, 1);
  },
  ADD_COMPANY(state: any, payload: any) {
    state.companies.push(payload);
  },
  SET_COMPANIES(state: any, payload: Company[]) {
    state.companies = payload;
  },
  UPDATE_COMPANY(state: any, payload: any) {
    const index = state.companies.findIndex(
      (company: Company) => company.id === payload.id
    );
    state.companies.splice(index, 1, payload);
  },
  ...make.mutations(state),
  SET_ERROR(state: any, error: any) {
    errorCatch(state, error);
  },
  CLEAR_ERROR(state: any) {
    state.error = {};
  }
};

export const actions = {
  clearError: ({ commit }: any) => commit('CLEAR_ERROR'),

  createCompany: async ({ commit, dispatch }: any, payload: Company) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      companyService
        .createCompany(payload)
        .then(res => {
          commit('ADD_COMPANY', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  fetchCompanies: async ({ commit, dispatch }: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      companyService
        .fetchCompanies()
        .then(res => {
          commit('SET_COMPANIES', res);
          resolve();
        })
        .catch(err => {
          // // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  fetchCompany: async ({ commit }: any, payload: number) => {
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      companyService
        .fetchCompany(payload)
        .then((company: Company) => {
          const index = state.companies.findIndex(
            (c: Company) => c.id === payload
          );
          if (index === -1) {
            commit('ADD_COMPANY', company);
          } else {
            commit('UPDATE_COMPANY', company);
          }
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  updateCompany: async ({ commit, dispatch }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      companyService
        .updateCompany(payload.id, payload.data)
        .then(res => {
          commit('UPDATE_COMPANY', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  deleteCompany: async ({ commit, dispatch }: any, payload: number) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      companyService
        .deleteCompany(payload)
        .then(res => {
          commit('REMOVE_COMPANY', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  }
};

export const getters = {
  getLoading: (state: any) => state.loading,
  getCompanyById: (state: any) => (id: number): Company => {
    return state.companies.find((company: Company) => company.id === id);
  }
};
